<template>
  <div class="d-flex justify-content-between align-items-center mb-3 bg-white p-3 rounded shadow-sm">
    <button class="btn btn-sm btn-primary" @click="$emit('add-user')">
      <i class="bi bi-plus-lg me-1"></i> Add User
    </button>

    <div class="d-flex align-items-center gap-2">
      <select
        v-model="sortKey"
        class="form-select form-select-sm w-auto"
        @change="handleSort"
      >
        <option value="id">ID</option>
        <option value="name">Name</option>
      </select>

      <button
        class="btn btn-sm btn-outline-secondary btn-light d-flex align-items-center"
        @click="toggleSortOrder"
        :title="sortOrder === 'asc' ? 'Ascending' : 'Descending'"
      >
        <i :class="sortOrder === 'asc' ? 'bi bi-sort-up' : 'bi bi-sort-down'"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    users: {
      type: Array,
      required: true,
    },
    defaultSort: {
      type: String,
      default: "id",
    },
  },
  data() {
    return {
      sortKey: this.defaultSort,
      sortOrder: "desc",
    };
  },
  methods: {
    handleSort() {
      const sorted = [...this.users].sort((a, b) => {
        let result = 0;

        if (this.sortKey === "id") result = a.id - b.id;
        else if (this.sortKey === "name") result = a.name.localeCompare(b.name);

        return this.sortOrder === "asc" ? result : -result;
      });

      this.$emit("sorted", sorted);
    },
    toggleSortOrder() {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      this.handleSort();
    },
  },
  mounted() {
    this.handleSort();
  },
  watch: {
    users: {
      handler(newUsers) {
        if (newUsers && newUsers.length) {
          this.handleSort();
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
